import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import pvc from "../assets/img/Single_PVC_PVC-removebg.png";
import singlecore from "../assets/img/Single_core_PVC-removebg-preview.png";
import pvcswa from "../assets/img/PVC_SWA_PVC-removebg-preview.png";
import flex from "../assets/img/Flex-removebg-preview.png";
import xlpe from "../assets/img/XLPE-removebg-preview.png";
import barecopper from "../assets/img/Bare_copper-removebg-preview.png";
import pvcpvc from "../assets/img/PVC_PVC-removebg-preview.png";
import pvcpvcflat from "../assets/img/PVC_PVC_FLAT-removebg-preview.png";
import aluminium from "../assets/img/Aluminium_conductor-removebg-preview.png";
import { useDispatch, useSelector } from "react-redux";
import { addToQuote } from "../redux/slices/FavouriteItemSlice";
import { RootState } from "../redux/Store";

interface QuotedItem {
  id: string;
  name: string;
  image: string;
  price: string;
  specs: string; // User-entered specifications
}

// Define Product Type
interface Product {
  id: number;
  name: string;
  price: string;
  image: string;
  description: string;
}

// Product List
const products: Product[] = [
  {
    id: 1,
    name: "Single PVC PVC",
    price: "$120",
    image: pvc,
    description: `1c X 300 sqmm Stranded Circular Copper Conductor, PVC Insulated, PVC Sheathed, 0.6/1kV Cable made to BS 6346 / NIS/IEC 60502-1`,
  },
  {
    id: 2,
    name: "Single Core PVC",
    price: "$180",
    image: singlecore,
    description: `1c x 10 sqmm Stranded Circular Copper Conductor, PVC Insulated, (green/yellow) Non Sheathed, Earthing Cable made to BS 6004 / NIS/IEC 60227-3`,
  },
  {
    id: 3,
    name: "PVC SWA PVC",
    price: "$95",
    image: pvcswa,
    description: "4c x 50mm² STRANDED CU/PVC/PVC/SWA/PVC",
  },
  {
    id: 4,
    name: "Flex",
    price: "$75",
    image: flex,
    description: `4c x 2.5mm² FLEX CU/PVC/PVC`,
  },
  {
    id: 5,
    name: "XLPE",
    price: "$175",
    image: xlpe,
    description: `1c X 50Omm XLPE/AWA Copper Conductor, XLPE Insulated PVC bedded, Round aluminium wire armoured, overall PVC sheathed 0.6/ 1KV cable made to IEC 60502 - 1/ BS; 3457`,
  },
  {
    id: 6,
    name: "Bare Copper",
    price: "$45",
    image: barecopper,
    description: `1c X 70mm Bare Copper`,
  },
  {
    id: 7,
    name: "PVC PVC",
    price: "$15",
    image: pvcpvc,
    description: `4c X 25 sqmm Stranded Compacted Circular/Stranded Shaped Copper Conductor, PVC Insulated, PVC Sheathed. 0.6/1kV Cable made to BS 6346/ NIS/|EC 60502-1`,
  },
  {
    id: 8,
    name: "PVC PVC Flat",
    price: "$55",
    image: pvcpvcflat,
    description: `2c x 1.5 sqmm Copper Conductor, PVC Insulated, PVC Sheathed, Flat Surface Cable made to BS 6004`,
  },
  {
    id: 9,
    name: "Aluminium Conductor",
    price: "$55",
    image: aluminium,
    description: `150 sqmm (30/2.59mm AL. + 7/2.59mm Steel) Aluminium Conductor, Steel Reinforced (ACSR)`,
  },
];

function Popular() {
  const userProfile = useSelector((state: RootState) => state?.Profile[0]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [specs, setSpecs] = useState<string>("");

  // Function to open modal
  const openModal = (product: Product) => {
    if (!userProfile) {
      alert("Please log in to add to cart");
      navigate("/auth");
    } else {
      setSelectedProduct(product);
      setSpecs(""); // Reset input when a new product is selected
    }
  };

  // Function to close modal
  const closeModal = () => {
    setSelectedProduct(null);
  };

  // Function to handle form submission

  const handleSubmit = (product: QuotedItem, specs: string) => {
    if (!specs.trim()) {
      alert("Please enter specifications.");
      return;
    }

    dispatch(
      addToQuote({
        id: `${product.id}-${Date.now()}`, // Unique ID for each quoted item
        name: product.name,
        image: product.image,
        price: product.price,
        specs, // User-entered details
      })
    );

    alert(`Added ${product.name} with specs: ${specs} to quote.`);
    closeModal();
  };

  return (
    <div className="my-2 md:my-10 w-full text-center font-serif">
      <div className="md:mx-[30vw] my-10 py-1 md:py-3 px-5 md:px-10 bg-primary rounded-md mx-[4rem]">
        <div className="items-center text-white mx-auto">
          <h1 className="text-lg md:text-xl font-bold">Popular Products</h1>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-12 md:gap-6">
        {products.map((product) => (
          <div
            key={product.id}
            className="bg-gray-50 shadow-lg rounded-lg overflow-hidden transform hover:scale-105 transition duration-300 mx-6"
          >
            <img
              src={product.image}
              alt={product.name}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <h2 className="text-lg font-semibold text-gray-800">
                {product.name}
              </h2>
              {/* <p className="text-gray-600 mt-1">
                {product.description.slice(0, 50)}...
              </p> */}
              <button
                className="mt-2 w-full bg-primary text-white py-1 rounded-lg hover:bg-primary-dark transition text-[0.9rem]"
                onClick={() => openModal(product)}
              >
                Add to Quote
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-20 mx-auto">
        <Link
          to={"/products"}
          className="bg-primary py-2 md:py-3 px-4 md:px-7 rounded text-white shadow-lg hover:bg-primary-dark"
        >
          View All
        </Link>
      </div>

      {/* Modal */}
      {selectedProduct && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-lg font-semibold mb-2">
              Specify details for {selectedProduct.name}
            </h2>
            <p className="text-gray-600 mt-1 text-sm">
              {selectedProduct.description}
            </p>
            <textarea
              className="w-full border rounded p-2 mt-2"
              rows={4}
              placeholder="Enter the specifications you need..."
              value={specs}
              onChange={(e) => setSpecs(e.target.value)}
            />
            <div className="flex justify-end gap-2 mt-4">
              <button
                onClick={closeModal}
                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
              >
                Cancel
              </button>
              <button
                onClick={() =>
                  handleSubmit(
                    {
                      id: `${selectedProduct?.id}-${Date.now()}`, // Unique ID
                      name: selectedProduct?.name || "",
                      image: selectedProduct?.image || "",
                      price: selectedProduct?.price || "",
                      specs, // Make sure `specs` is defined somewhere
                    },
                    specs // Pass specs separately
                  )
                }
                className="bg-primary text-white px-4 py-2 rounded hover:bg-primary-dark"
              >
                Get A Quote
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Popular;
